import React, { useState } from 'react';
import { BarChart3, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

const Polls = () => {
  const [hasVoted, setHasVoted] = useState(false);
  
  const [pollOptions, setPollOptions] = useState([
    { id: 1, text: "अलखनाथ मंदिर", votes: 450, percentage: 45 },
    { id: 2, text: "त्रिवटी नाथ मंदिर", votes: 320, percentage: 32 },
    { id: 3, text: "मढ़ीनाथ मंदिर", votes: 150, percentage: 15 },
    { id: 4, text: "धोपेश्वरनाथ मंदिर", votes: 80, percentage: 8 }
  ]);

  const handleVote = (id) => {
    if (hasVoted) return;
    
    const updatedOptions = pollOptions.map(option => {
      if (option.id === id) {
        return { ...option, votes: option.votes + 1 };
      }
      return option;
    });

    const totalVotes = updatedOptions.reduce((acc, curr) => acc + curr.votes, 0);
    const optionsWithPercentages = updatedOptions.map(option => ({
      ...option,
      percentage: Math.round((option.votes / totalVotes) * 100)
    }));

    setPollOptions(optionsWithPercentages);
    setHasVoted(true);
  };

  const totalVotes = pollOptions.reduce((acc, curr) => acc + curr.votes, 0);

  return (
    <div className="min-h-screen bg-stone-50 py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="mb-12 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-saffron-100 p-4 rounded-full">
              <BarChart3 className="w-8 h-8 text-saffron-600" />
            </div>
          </div>
          <h1 className="text-4xl font-extrabold text-stone-900 tracking-tight mb-4">सक्रिय मतदान</h1>
          <p className="text-stone-600 max-w-xl mx-auto">सामुदायिक चुनावों में भाग लें और देखें कि बरेली के प्राचीन मंदिरों के बारे में अन्य भक्त क्या सोचते हैं।</p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl shadow-stone-200/50 border border-stone-100 p-8 md:p-12">
          <h2 className="text-2xl font-bold text-stone-900 mb-8 border-b border-stone-100 pb-4">
            आप सबसे ज्यादा किस नाथ मंदिर जाते हैं?
          </h2>

          <div className="space-y-6">
            {pollOptions.map((option) => (
              <div 
                key={option.id}
                onClick={() => handleVote(option.id)}
                className={`relative rounded-xl border-2 transition-all p-4 cursor-pointer overflow-hidden ${
                  hasVoted ? 'border-stone-100 cursor-default' : 'border-stone-200 hover:border-saffron-400 group'
                }`}
              >
                {hasVoted && (
                  <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: `${option.percentage}%` }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="absolute inset-0 bg-saffron-50 -z-10"
                  ></motion.div>
                )}
                
                <div className="flex items-center justify-between relative z-10">
                  <span className={`font-medium ${hasVoted ? 'text-stone-800' : 'text-stone-700 group-hover:text-saffron-700 transition-colors'}`}>
                    {option.text}
                  </span>
                  
                  {hasVoted ? (
                    <div className="text-right">
                      <span className="block font-bold text-saffron-700">{option.percentage}%</span>
                      <span className="text-xs text-stone-500">{option.votes} वोट</span>
                    </div>
                  ) : (
                    <div className="w-6 h-6 rounded-full border-2 border-stone-300 group-hover:border-saffron-400 transition-colors flex items-center justify-center">
                      <div className="w-2.5 h-2.5 rounded-full bg-saffron-500 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {hasVoted && (
            <motion.div 
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="mt-8 p-4 bg-green-50/80 rounded-xl text-center border border-green-100"
            >
              <div className="flex items-center justify-center space-x-2 text-green-700">
                <CheckCircle2 className="w-5 h-5" />
                <span className="font-semibold text-sm">मतदान के लिए धन्यवाद!</span>
              </div>
              <p className="text-xs text-green-600/80 mt-1">अब तक {totalVotes} भक्तों ने मतदान किया है।</p>
            </motion.div>
          )}

        </div>

      </div>
    </div>
  );
};

export default Polls;
